import React from "react";
import { Helmet } from "react-helmet";
import { getCurrentUrl } from "../../utils";

interface IProps {
  title: string;
  description: string;
  keywordsContent: string;
  url?: string;
  metaNameTags?: { name: string; content: string }[];
  conditionalTags?: any;
  ogImage?: string;
  customJsonScript?: any;
}

export const SEO: React.FC<IProps> = ({
  title,
  description,
  keywordsContent,
  url,
  metaNameTags,
  conditionalTags,
  ogImage = "https://fiddlepiddle.com/og.jpg",
  customJsonScript,
}: IProps) => {
  const ldJson_1 = {
    "@context": "http://schema.org",
    "@type": "WebSite",
    "@id": "#website",
    url: "https://fiddlepiddle.com/",
    name: "FiddlePiddle",
    potentialAction: {
      "@type": "SearchAction",
      target: "https://fiddlepiddle.com/?s={search_term_string}",
      "query-input": "required name=search_term_string",
    },
  };
  const ldJson_2 = {
    "@context": "http://schema.org",
    "@type": "Organization",
    name: "FiddlePiddle",
    logo: "https://fiddlepiddle.com/favicon.png",
    url: "https://fiddlepiddle.com",
    sameAs: [
      "https://www.facebook.com/fiddlepiddle",
      "https://twitter.com/PiddleFiddle",
      "https://www.youtube.com/channel/UCpGnI-i7PeKoUXmsp0nhVZw",
      "https://play.google.com/store/apps/details?id=com.alaaclips.fiddlepiddle",
      "https://apps.apple.com/app/id1597349309",
    ],
  };

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywordsContent} />
      {metaNameTags &&
        metaNameTags.map((item) => {
          return <meta name={item.name} content={item.content} />;
        })}
      <meta name="author" content="FiddlePiddle" />
      <meta name="ROBOTS" content="INDEX, FOLLOW" />
      <meta
        name="google-site-verification"
        content="U5_ASxQJa6MP8WpBqW8WC-9kRtxcEFgFH5k80Fs3n8o"
      />
      <meta property="og:locale" content="en_US" />
      <meta property="og:title" content={title} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={getCurrentUrl()} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:description" content={description} />
      <meta property="og:site_name" content="FiddlePiddle" />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:image" content={ogImage} />
      <meta name="theme-color" content="#f9e8de" />
      <meta name="msapplication-navbutton-color" content="#f9e8de" />
      <meta name="apple-mobile-web-app-status-bar-style" content="#f9e8de" />
      <link rel="canonical" href={getCurrentUrl()} />
      {conditionalTags}
      <meta name="mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <script type="application/ld+json">{JSON.stringify(ldJson_1)}</script>
      <script
        async
        src="https://www.googletagmanager.com/gtag/js?id=UA-48660480-19"
      ></script>
      <script type="application/ld+json">{JSON.stringify(ldJson_2)}</script>
      <script type="application/ld+json">{JSON.stringify(customJsonScript)}</script>
    </Helmet>
  );
};
